import { batch } from '@tanstack/store';

/**
 * Sometimes reset form is not updating values correctly
 * and replaces new form values with the default ones.
 * This function resets the fileds meta to remove form dirty and touched state.
 */
export const resetFormMeta = (form) => {
  if (!form?.fieldInfo) return;
  batch(() => {
    Object.values(form.fieldInfo).forEach((field) => {
      if (!field.instance) return;
      field.instance.setMeta((prev) => ({
        ...prev,
        isTouched: false,
        isDirty: false,
      }));
    });
  });
};

export const setFormSubmitErrors = (form, errors) => {
  if (!errors) return;
  batch(() => {
    Object.entries(errors).forEach(([key, error]) => {
      if (form.fieldInfo[key]) {
        form.setFieldMeta(key, (prev) => ({
          ...prev,
          errorMap: { onSubmit: error },
          isTouched: true,
        }));
      }
    });
  });
};
